
import './styles.css';
import InsaneTable from '../../component/insane-table'

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function ProductionResultPD() {

    let plantList = [];
    
    // HttpRequest("/admin/pd/plant/get", {}).then(data => {
    //     console.log("/admin/pd/plant/get --->", data);
    //     if (data.result === "OK") {
    //         for (let i = 0; i < data.plants.length; i++) {
    //             const _plant = data.plants[i];
    //             plantList.push({
    //                 displayName: _plant.plantid + " (" + _plant.plantname + ")" ,
    //                 value: _plant.plantid
    //             })
    //         }
    //     }
    // });

    const tableOption = {
        tableName: "Plant",
        className: "",
        search: [
            // {
            //     reqName: "plantid",
            //     displayName: "Plant ID",
            //     placeholder: "Select Plant ID.",
            //     element: "select",
            //     option: plantList
            // }
        ],
        mapTable: [
            {
                displayName: "Plant ID",
                attName: "plantid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Plantname",
                attName: "plantname",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/pd/plant/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "plantid": ""
                }
            },
            insert: {
                enable: false,
                url: "/admin/pd/plant/update",
                dataReq: {
                    "plantid": "",
                    "reportemail": "",
                    "checksheetname": ""
                }
            },
            update: {
                enable: false,
                url: "/admin/pd/plant/update",
                dataReq: {
                    "checksheetid": "",
                    "plantid": "",
                    "reportemail": "",
                    "checksheetname": ""
                }
            },
            delete: {
                enable: false,
                url: "/admin/pd/plant/delete",
                dataReq: {
                    "checksheetid": ""
                }
            }
        },
        action: [
            // {
            //     name: "Edit",
            //     mode: "modal-form", /// page, modal, form
            //     option: {
            //         type: "update"
            //     }
            // },
            {
                name: "Check Sheet",
                mode: "page", /// page, modal, form
                option: {
                    url: "/d-rec-admin/main/production/result-pd/checksheet"
                }
            }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Select Plant.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >);
}

export default ProductionResultPD;